// extracted by mini-css-extract-plugin
export default {"wrapper":"TitleAndDesc_wrapper__SeskR","title":"TitleAndDesc_title__VPXMe","description":"TitleAndDesc_description__xF7cU"};